<template>
  <div>
    <div class="row">
      <div class="col-md-4">
        <card class="card" title="Empty Out Bin(s)">
          <div>
            <form @submit.prevent>
              <div class="row">
                <div class="col-md-12">
                  <fg-input type="text" label="Barcode ID" v-model="toEmpty.barcode" @keyup.enter.native="getOrderByBarcodeID">
                  </fg-input>
                </div>
              </div>

              <div class="row"></div>

              <div class="row"></div>

              <div class="row"></div>

              <div class="text-center">
                <p-button
                  type="info"
                  round
                  @click.native.prevent="getOrderByBarcodeID"
                >
                  Empty Bin(s)
                </p-button>
              </div>
              <div class="clearfix"></div>
            </form>
          </div>
        </card>
      </div>
      <div class="col-md-7">
        <div v-if="warning" class="alert alert-danger alert-with-icon" style="font-size:20px;"  data-notify="container">
          <button type="button" aria-hidden="true" @click="close1" class="ti-close"></button>
          <span data-notify="icon" class="ti-pie-chart"></span>
          <br />
          <span data-notify="message"><b>{{warningMessage}}</b></span>
        </div>
        <div v-if="duplicate" class="alert alert-info alert-with-icon" style="font-size:20px;"  data-notify="container">
          <button type="button" aria-hidden="true" @click="close2" class="ti-close"></button>
          <span data-notify="icon" class="ti-pie-chart"></span>
          <br />
          <span data-notify="message"><b>{{duplicateMessage}}</b></span>
        </div>
        <div v-if="ready" class="alert alert-success alert-with-icon" style="font-size:20px;"  data-notify="container">
          <button type="button" aria-hidden="true" @click="close3" class="ti-close"></button>
          <span data-notify="icon" class="ti-pie-chart"></span>
          <br />
          <span data-notify="message"><b>{{readyMessage}}</b></span>
        </div>
      </div>
    </div>
    
    
  </div>
</template>
<script>
import * as shelveOrderService from "../../services/shelveOrder.service";
import { EventBus } from "@/event-bus";
import Card from '../../components/Cards/Card.vue';

export default {
  name: "emptyform",
  data() {
    return {
      toEmpty: {
        barcode: "",
        notes: "",
      },
      racks: null,
      shipReady: false,
      badMessage: "",
      warning: false,
      duplicate: false,
      ready: false,
      warningMessage: "ERROR! :::: ",
      duplicateMessage: "DUPLICATE! :::: ",
      readyMessage: "",
    };
  },
  // created() {
  //   this.$root.$refs.emptyform_component = this;
  // },
  mounted: function (event) {
    this.$root.$on('emptyForm1', (bin) => {
      this.toEmpty.barcode = bin;
      this.getOrderByBarcodeID();
    })
    const self = this;
    const addToListHandler = function (bin) {
      //console.log("About to Empty Bin:" + bin);
      //console.log("WE GOT HERE");
      self.toEmpty.barcode = bin;
      self.getOrderByBarcodeID();
    };
    EventBus.$on("emptyBin", addToListHandler);
  },
  methods: {
    close1: function() {
      this.warning = !this.warning;
    },
    close2: function() {
      this.duplicate = !this.duplicate;
    },
    close3: function() {
      this.ready = !this.ready;
    },
    setUpWarning: function(message) {
      this.warningMessage = "ERROR! :::: ";
      this.warningMessage += message;
      this.ready = false;
      this.duplicate = false;
      this.warning = true;
    },
    emitGetOrderEvent: function (order) {
      EventBus.$emit("empty", order);
    },
    getOrderByBarcodeID: function () {
      let barcodeID = this.toEmpty.barcode;
      if (barcodeID == "") {
        this.setUpWarning("Please enter a Barcode.");
        return;
      }
      shelveOrderService.getBins().then((response) => {
        //console.log("response::: " + JSON.stringify(response));
        this.racks = JSON.parse(response.items[0]['rackMaps']);
        this.emptyBins(barcodeID);
        //response.items.error ? "swal" : this.findLocation(response); 
        //this.emitGetOrderEvent(response);
      })
      .catch((err) => {
        console.log("error barcode: " + JSON.stringify(err.message));
        this.setUpWarning(JSON.stringify(err.message));
      });
    },
    checkBins: function(barcodeID) {
      //console.log("Checking Bins");
      this.warning = false;
      let arrCounter = 0;
      const splitArr = barcodeID.split("-");
      let location = splitArr[1];
      let num = splitArr[2];
      let parsedNum = parseInt(num, 10);
      //console.log("Bin Scanned:");
      //console.log(parsedNum);
      let currRacks = this.racks[location];
      let currSpaceArr;
      if (currRacks) {
        currSpaceArr = currRacks["spaceArr"];
      } else {
        this.setUpWarning("THAT RACK DOES NOT EXIST CURRENTLY.")
        return false;
      }
      for (let i=0; i < currSpaceArr.length; i++) {
        for (let j=0; j < currSpaceArr[i].length; j++) {
          arrCounter += 1;
          //console.log("BIN #: " + arrCounter);
          if (arrCounter == parsedNum) {
            if (currSpaceArr[i][j] == 1) {
              return true;
            } else {
              return false;
            }
          }
        }
      }
      return false;
    },
    emptyBins: function(barcodeID) {
      let binChecked = this.checkBins(barcodeID);
      if (!binChecked) {
        if (!this.warning) {
          this.setUpWarning("Those Bin(s) are already empty");
        }
        this.toEmpty.barcode = "";
        return;
      }
      //console.log("Emptying Out::: ");
      //console.log(barcodeID);
      const splitArr = barcodeID.split("-");
      //console.log("After Split");
      //console.log(splitArr);
      //console.log(barcodeID);
      let location = splitArr[1];
      //console.log(location);
      let togetherObj = this.racks[location]["together"];
      //console.log(togetherObj);
      let togetherKeys = Object.keys(togetherObj);
      let togetherCopy;
      let orderId;
      togetherLoop:
      for (let i=0; i < togetherKeys.length; i++) {
        let index = togetherKeys[i];
        //console.log(index);
        //console.log(togetherObj[index]);
        //console.log(barcodeID in togetherObj[index]);
        //console.log(togetherObj[index][0]);
        for (let j=0; j < togetherObj[index].length; j++) {
          if (barcodeID == togetherObj[index][j]) {
            //console.log("Found Barcode in Together");
            togetherCopy = [...togetherObj[index]];
            orderId = index;
            delete this.racks[location]["together"][index]
            //console.log("After Together Deletion");
            //console.log(this.racks);
            break togetherLoop;
          }
        }
      }
      //console.log("All Bins: ")
      //console.log(togetherCopy);
      //console.log(orderId);
      let numArr = [];
      let binArr = [];
      for (let i=0; i < togetherCopy.length; i++) {
        let currCode = togetherCopy[i];
        let splitCode = currCode.split("-");
        let letter = splitCode[1];
        let num = splitCode[2];
        let parsedNum = parseInt(num, 10);
        //console.log(parsedNum);
        numArr.push(parsedNum);
        binArr.push(letter + parsedNum);
      }
      //console.log("Numbers to Change");
      //console.log(numArr);
      //console.log("Bins to Free");
      //console.log(binArr);
      
      let currSpaceArr = this.racks[location]["spaceArr"];
      let arrCounter = 0;
      let changeCounter = 0;
      
      secondSpaceLoop:
      for (let i=0; i < currSpaceArr.length; i++) {
        for (let j=0; j < currSpaceArr[i].length; j++) {
          arrCounter += 1;
          //console.log("BIN #: " + arrCounter);
          for (let k=0; k < numArr.length; k++) {
            if (numArr[k] == arrCounter) {
              //console.log("Found Number");
              if (currSpaceArr[i][j] == 1) {
                //console.log("Changing a 1 to a 0");
                currSpaceArr[i][j] = 0;
                changeCounter += 1;
                if (changeCounter == numArr.length) {
                  //console.log("Leaving the Loop");
                  break secondSpaceLoop;
                }
              }
            }
          }
        }
      }
      this.racks[location]["spaceArr"] = currSpaceArr;
      //console.log("Number of Bins Being Opened Up: "+ changeCounter);
      //console.log(this.racks[location]["used"]);
      this.racks[location]["used"] = this.racks[location]["used"] - changeCounter;
      //console.log(this.racks[location]["used"]);
      let dataArr = this.racks[location][orderId];
      let dataStr = JSON.stringify(this.racks[location][orderId]);
      delete this.racks[location][orderId];
      //console.log("Almost at the End");
      shelveOrderService.deleteOrder(orderId).then(response => {
        //console.log("Order Emptied from Bins");
        //console.log(orderId);
        //console.log(response);
        shelveOrderService.updateRacks(this.racks).then(response => {
          //console.log("Updated Racks While Emptying");
          //console.log(response);
          shelveOrderService.storeRacks(this.racks, location).then(response => {
            //console.log("Rack Histories Updated While Emptying");
            //console.log(response);
            let myBins = JSON.stringify(binArr);
            let emptyObj = {
              op_order_id: orderId,
              rack: location,
              data: dataStr,
            }
            shelveOrderService.empty(emptyObj).then(response => {
              //console.log("Finished Emptying Out Order:: " + orderId);
              //console.log("Empty Info sent to Empties.");
              //console.log(response);
              this.readyMessage = `Order: ${orderId} in bin(s): ${myBins} has left the racks.`;
              this.warning = false;
              this.ready = true;
              this.toEmpty.barcode = "";
              let myOrder = {
                binBarcodes: togetherCopy,
                reference_id: orderId,
                bins: myBins,
                total_quantity: dataArr.total_qty,
              }
              this.emitGetOrderEvent(myOrder);
            }).catch((err) => {
              console.log("Error Sending to Empties:::: " + JSON.stringify(err.message));
              console.log(barcodeID);
              this.setUpWarning(JSON.stringify(err.message));
            });
            
          }).catch((err) => {
            console.log("Error Storing Racks:::: " + JSON.stringify(err.message));
            console.log(barcodeID);
            this.setUpWarning(JSON.stringify(err.message));
          });
        }).catch((err) => {
          console.log("Error Updating Racks::::" + JSON.stringify(err.message));
          console.log(barcodeID);
          this.setUpWarning(JSON.stringify(err.message));
        });
      }).catch((err) => {
        console.log("Error Deleting From Binned Orders::::" + JSON.stringify(err.message));
        console.log(barcodeID);
        this.setUpWarning(JSON.stringify(err.message));
      });
      
      return;
    }
  },
};
</script>
<style>
</style>